'use client';
import '../../../css/footer.scss'
import Link from "next/link";
import {LINK_PRIVACY, LINK_TERMS, LINK_BLOG_POSTS} from "@constants/page-links";

import {LINK_TIPS_LIST} from "@constants/page-links/tips";
import {LINK_CSR, LINK_NEWS_LIST, LINK_OUR_STORY, LINK_TEAM} from "@constants/page-links/news";

import {useEffect, useState, useTransition} from 'react';
import {usePathname, useRouter} from 'next/navigation';
import {
    FaFacebookF,
    FaLinkedinIn,
    FaInstagram,
    FaYoutube,
    FaWhatsapp
} from 'react-icons/fa';



export default function PageFooter(
    
    {}
) {
    const router = useRouter();
    const [isPending,startTransition] = useTransition();

    const handleNavigation = (href) => {

        startTransition(() => {
            router.push(href);
        });
    };
    return (
        <footer className="page-footer">

            <div className="container">
                <div className="footer-widgets">
                    <div className="widget">
                        <h3>Important Information</h3>

                        <ul>
                            <li>
                                <Link href={LINK_TERMS} style={{color: '#fff !important'}}>Terms & Conditions</Link>
                            </li>
                            <li>
                                <Link href={LINK_PRIVACY} style={{color: '#fff !important'}}>Privacy Policy</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="widget resourse-links">
                      

                        {/*  <h3>Opening Hours</h3>
                         <ul>
                            <li>
                                <span className="info">9:00am – 7:00pm</span>
                            </li>
                            <li>
                                <span className="info">Monday – Friday</span>
                            </li>
                            <li>
                                <span className="info">10:00am – 6:00pm</span>
                            </li>
                            <li>
                                <span className="info">Saturday</span>
                            </li></ul> */}
                            <h3>Resources</h3>

                        <ul>

                            <li className="">
                                <Link href={LINK_BLOG_POSTS} onClick={() => handleNavigation(LINK_BLOG_POSTS)}>
                                    Blog
                                </Link>
                            </li>

                            <li className="">
                                <Link href={LINK_TIPS_LIST} onClick={() => handleNavigation(LINK_TIPS_LIST)}>
                                    Tips & Insights
                                </Link>
                            </li>

                            <li className="">
                                <Link href={LINK_NEWS_LIST} onClick={() => handleNavigation(LINK_NEWS_LIST)}>
                                    Latest News
                                </Link>
                            </li>

                            <li className="">
                                <Link href={LINK_CSR} onClick={() => handleNavigation(LINK_CSR)}>
                                    CSR
                                </Link>
                            </li>
                            <li className="">
                                <Link href={LINK_TEAM} onClick={() => handleNavigation(LINK_TEAM)}>
                                    Our Team
                                </Link>
                            </li>

                            <li className="">
                                <Link href={LINK_OUR_STORY} onClick={() => handleNavigation(LINK_OUR_STORY)}>
                                    Our Story
                                </Link>
                            </li>

                        </ul>


                        
                    </div>

                    <div className="widget">
                        <h3>Contact</h3>

                        <ul>
                            <li>
                                <span className="info">ICUK Insurance</span>
                            </li>
                            <li><span className="info">330 Upper Parliament Street </span></li>
                            <li><span className="info">Liverpool, England, United Kingdom, L8 7QL</span></li>
                            <li>
                                <span className="info">Email:</span> <Link href="mailto:quote@icukinsurance.co.uk" style={{color: '#fff !important'}}>quote@icukinsurance.co.uk</Link>
                            </li>
                            <li>
                                <span className="info">Telephone:</span> <Link href="tel:01517095888" style={{color: '#fff !important'}}>01517095888</Link>
                            </li>
                        </ul>
                    <div className="social-icons">
                        <a
                            href="https://www.facebook.com/icukinsurance/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="facebook"
                        >
                            <FaFacebookF />
                        </a>

                        <a
                            href="https://www.instagram.com/icukinsurance/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="instagram"
                        >
                            <FaInstagram />
                        </a>

                        <a
                            href="https://www.linkedin.com/company/icuk-insurance-corporation"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="linkedin"
                        >
                            <FaLinkedinIn />
                        </a>

                        <a
                            href="https://wa.me/+447487664761"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp"
                        >
                            <FaWhatsapp />
                        </a>

                        <a
                            href="https://www.youtube.com/@icukconsultancy4064"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="youtube"
                        >
                            <FaYoutube />
                        </a>
                    </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">

              ICUK Insurance is a trading name of ICUK Corporation Limited, registered in England & Wales under registration number: 15956123, Registered Office: 330 Upper Parliament Street Liverpool, England, United Kingdom, L8 7QL. ICUK Corporation Limited is registered with Information Commissioner&#39;s Office under registration number: ZB845804, authorised to process personal data under The General Data Protection Regulation (GDPR) (EU) 2016/679 (The Data Protection Act 2018). ICUK Insurance is Compliant with Payment Card Industry Data Security Standards (PCI DSS). ICUK ICUK Insurance does not engage in any regulated activities as described under the FSMA Act 2000, Order 2001 (RAO) and the FCA Handbook.
                </div>
                  <h3>Opening hours: <span> 9:00am to 7:00pm, Monday to Saturday. Sunday closed. Open on bank holidays. Closed on Christmas Day and New Year’s Day</span></h3>
            </div>

        </footer>
    );

}
